import React from "react";

import { css, keyframes } from "@emotion/css";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import Phones from "../../../img/png/tech/phones.png";
import Phone1 from "../../../img/png/tech/phone-1.png";
import Phone2 from "../../../img/png/tech/phone-2.png";
import Phone3 from "../../../img/png/tech/phone-3.png";
import Phone4 from "../../../img/png/tech/phone-4.png";
import { useI18n } from "../../../i18n";

const Essence = () => {
  const { t } = useI18n();
  return (
    <>
      <div className={style.phones}>
        <img src={Phones} alt="" />
      </div>
      <div className={style.container}>
        <div className="info">
          <h2>{t("tech_essence")}</h2>
          <p>
            {t("tech_essence_body")}
          </p>
        </div>
        <div className="animation">
          <div className="wrapper w2" aria-hidden="true">
            <img src={Phone1} alt="" />
            <img src={Phone2} alt="" />
            <img src={Phone3} alt="" />
            <img src={Phone4} alt="" />
          </div>
          <div className="wrapper">
            <img src={Phone1} alt="" />
            <img src={Phone2} alt="" />
            <img src={Phone3} alt="" />
            <img src={Phone4} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

const animation = keyframes({
  to: { transform: "translateX(-100%)" },
});

const style = {
  phones: css({
    backgroundColor: "#010101",
    height: 558,
    position: "relative",

    img: {
      position: "absolute",
      width: 1100,
      height: "auto",
      top: 0,
      left: 0,
      right: 0,
      margin: "auto",
      zIndex: 1,
    },

    [desktop]: {
      height: 508,

      img: {
        width: 950,
      },
    },

    [laptop]: {
      height: 400,

      img: {
        width: 800,
      },
    },

    [tablet]: {
      height: 200,

      img: {
        width: '100%',
        maxWidth: 450,
      },
    },
  }),
  container: css({
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    background:
      "linear-gradient(180deg, #FFF 0%, rgba(255, 255, 255, 0.20) 12.8%, #6643FF 97.86%)",
    paddingTop: 400,
    paddingBottom: 300,

    ".animation": {
      overflow: "hidden",
      maxWidth: "1400px",
      width: "100%",
      position: "relative",
      display: "flex",

      "&::before, &::after": {
        // This is needed from design
        // background:
        //   "linear-gradient(to right,  rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%)",
        // content: '""',
        // height: "100%",
        // position: "absolute",
        // width: 150,
        // zIndex: 1,
      },
      "&::after": {
        right: 0,
        top: 0,
        transform: "rotateZ(180deg)",
      },

      "&::before": {
        left: 0,
        top: 0,
      },

      ".wrapper": {
        animation: `${animation} 12s linear infinite`,
        flexShrink: 0,
        minWidth: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 0,

        img: {
          padding: 20,
          width: 378,
          height: 770,
        },
      },
    },
    ".info": {
      maxWidth: 1157,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-evenly",
      alignContent: "center",
      flexWrap: "nowrap",
      flexDirection: "row",
      gap: 30,
      marginBottom: 100,

      h2: {
        color: "#000",
        fontFamily: "Syne",
        fontSize: 84,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "98px",
        textTransform: "uppercase",
      },
      p: {
        color: "#000",
        fontFamily: "Inter",
        fontSize: 18,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
        letterSpacing: 0.36,
      },
    },
    [desktop]: {
      paddingTop: 300,
      paddingBottom: 150,
      alignItems: "stretch",

      ".animation": {
        maxWidth: "1400px",

        ".wrapper": {
          img: {
            padding: 15,
            width: 280,
            height: "auto",
          },
        },
      },
      ".info": {
        maxWidth: "100%",
        gap: 24,
        marginBottom: 80,
        paddingLeft: 60,
        paddingRight: 60,
        flexDirection: "column",
        alignItems: "flex-start",

        h2: {
          fontSize: 70,
          lineHeight: "77px",
          maxWidth: 729.884,
        },
        p: {
          fontSize: 18,
          maxWidth: 729.884,
        },
      },
    },
    [laptop]: {
      paddingTop: 300,
      paddingBottom: 150,

      ".animation": {
        ".wrapper": {
          img: {
            padding: 15,
            width: 240,
          },
        },
      },
      ".info": {
        gap: 20,
        marginBottom: 60,
        paddingLeft: 39,
        paddingRight: 39,

        h2: {
          fontSize: 60,
          lineHeight: "70px",
          maxWidth: 649,
        },
        p: {
          fontSize: 16,
          maxWidth: 649,
        },
      },
    },
    [tablet]: {
      paddingTop: 150,
      paddingBottom: 80,

      ".animation": {
        ".wrapper": {
          img: {
            padding: 15,
            width: 190,
          },
        },
      },
      ".info": {
        gap: 20,
        marginBottom: 30,
        paddingLeft: 20,
        paddingRight: 20,

        h2: {
          fontSize: 32,
          lineHeight: "38px",
          maxWidth: 335,
        },
        p: {
          fontSize: 14,
          maxWidth: 335,
        },
      },
    },
  }),
};

export default Essence;
